import { axiosInstance } from "../../axios-Instance";
import { getLoginToken } from "../../storage";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../react-query/constants";

async function getAssessment() {
  try {
    const { data: response } = await axiosInstance({
      url: "/iassessment",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getLoginToken()}`,
      },
    });

    const questions = response?.data ?? [];

    const items = questions.map((question: any) => {
      const randomizedOptions = Array.isArray(question.options)
        ? [...question.options].sort(() => Math.random() - 0.5)
        : [];
      return {
        ...question,
        options: randomizedOptions,
      };
    });

    return items;
  } catch (error) {
    console.error("Error fetching assessment:", error);
    return [];
  }
}

const createAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: "/iassessment",
    method: "POST",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};


const updateAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: `/iassessment/${formData["_id"]}`,
    method: "PUT",
    data: formData,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

const deleteAssessment = async (formData: any) => {
  const data = await axiosInstance({
    url: `/iassessment/${formData}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getLoginToken()}`,
    },
  });
  return data;
};

export function useIAssessment() {
  const fallback: any = [];
  const { data = fallback } = useQuery({
    queryKey: [queryKeys.iassessment],
    queryFn: () => getAssessment(),
  });
  return data;
}

export function useCreateIAssessment() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => createAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.iassessment]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useUpdateIAssessment() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => updateAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.iassessment]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}

export function useDeleteIAssessment() {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, reset, isError, error } = useMutation({
    mutationFn: (formData) => deleteAssessment(formData),
    onSuccess: (data) => {
      queryClient.invalidateQueries([queryKeys.iassessment]);
    },
  });
  return { mutate, isSuccess, reset, isError, error };
}
